import { ChangeDetectorRef, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { Router, RouterLinkActive } from '@angular/router';

@Directive({
    selector: '[extendedRouterLinkActive]',
    standalone: false
})
export class ExtendedRouterLinkActiveDirective extends RouterLinkActive {
  @Input() public set extendedRouterLinkActive(value: string) {
    this.routerLinkActive = [value];
  }
}
